(function ($) {
    $(function () {
        if (window.innerWidth > 768 && $('.box-triggers').length) {
            var boxWrapper = $('.box-triggers');

            function updateBoxClasses(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        boxWrapper.addClass('visible');
                    } else {
                        boxWrapper.removeClass('visible s1 s2 s3');
                    }
                });
            }

            var observer = new IntersectionObserver(updateBoxClasses, {
                root: null,
                threshold: [0, 0.33, 0.5, 1]
            });

            observer.observe(boxWrapper[0]);

            $(window).on('scroll', function () {
                var scrollTop = $(window).scrollTop();
                var boxWrapperPos = boxWrapper.offset().top;
                var boxWrapperHeight = boxWrapper.outerHeight();

                if (boxWrapper.hasClass('visible')) {
                    if (scrollTop >= boxWrapperPos - 96) {
                        boxWrapper.addClass('s1');
                    } else {
                        boxWrapper.removeClass('s1');
                    }

                    if (scrollTop >= (boxWrapperPos + boxWrapperHeight / 3)) {
                        boxWrapper.addClass('s2');
                    } else {
                        boxWrapper.removeClass('s2');
                    }

                    if (scrollTop >= (boxWrapperPos + boxWrapperHeight / 2)) {
                        boxWrapper.addClass('s3');
                    } else {
                        boxWrapper.removeClass('s3');
                    }
                }
            });

            $(document).on('click', '.content-toggle-text-btn', function () {
                setTimeout(function () {
                    observer.unobserve(boxWrapper[0]);
                    observer.observe(boxWrapper[0]);
                }, 1000);
            });
        }
    });
})(jQuery);
